import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { Table, Empty } from "antd";
import moment from "moment";
import { CardElement, HomePageTable } from "../../components/Common/UIElements";
import ViewReportCategoryTopBar from "../../components/ReportCategory/ViewReportCategory/ViewReportCategoryTopBar";
import { useGetProjectReportCategories } from "../../hooks/project.hooks";
import ExportExcel from "../../utils/export";
import { tableStringSorter, tableNumericSorter } from "../../utils/table";

const ViewReportCategory = () => {
  const [hmg, setHmg] = useState();
  const [project, setProject] = useState();
  const [projectList, setProjectList] = useState();

  const setHmgRef = useCallback((list) => {
    if (list?.length === 1) setHmg(list[0]._id);
  }, []);

  const setProjectRef = useCallback((list) => {
    setProjectList(list);
  }, []);

  useEffect(() => {
    setProject(
      projectList?.length === 1 && hmg ? projectList[0]._id : undefined,
    );
  }, [projectList, hmg]);

  const {
    data: reportCategoryList,
    isLoading: ReportCategoriesLoading,
    refetch,
  } = useGetProjectReportCategories(project, {
    enabled: false,
    cacheTime: 0,
    select: (data) => {
      const updatedData = [...data];
      return updatedData.map((e) => {
        return {
          ...e,
          create_by: e?.create_by?.name ?? "",
          create_at: e?.create_at
            ? moment(e.create_at).local().format("YYYY-MM-DD HH:mm:ss")
            : "",
          update_by: e?.update_by?.name ?? "",
          update_at: e?.update_at
            ? moment(e.update_at).local().format("YYYY-MM-DD HH:mm:ss")
            : "",
          allocated_hotels: e?.apply_all_hotels ? "All" : "",
        };
      });
    },
  });

  const columns = [
    {
      title: "Report Category",
      dataIndex: "name",
      key: "name",
      width: "200px",
      sorter: tableStringSorter("name"),
    },
    {
      title: "Allocated Hotels",
      dataIndex: "allocated_hotels",
      key: "allocated_hotels",
      width: "200px",
      sorter: tableStringSorter("allocated_hotels"),
    },
    {
      title: "Created by",
      dataIndex: "create_by",
      key: "create_by",
      width: "200px",
      // ...getColumnSearchProps("create_by"),
      sorter: tableStringSorter("create_by"),
    },
    {
      title: "Created at",
      dataIndex: "create_at",
      key: "create_at",
      width: "170px",
      // ...getColumnSearchProps("create_at"),
      sorter: tableNumericSorter("create_at"),
    },
    {
      title: "Updated by",
      dataIndex: "update_by",
      key: "update_by",
      width: "200px",
      // ...getColumnSearchProps("update_by"),
      sorter: tableStringSorter("update_by"),
    },
    {
      title: "Updated at",
      dataIndex: "update_at",
      key: "update_at",
      width: "170px",
      // ...getColumnSearchProps("update_at"),
      sorter: tableNumericSorter("update_at"),
    },

  ];

  let tableHeight = 500;
  if (window.innerWidth > 700) {
    tableHeight = window.innerHeight - 375;
  }

  const retrieveCategoryData = () => {
    refetch()
  }

  const exportOnClick = () => {
    ExportExcel(columns, reportCategoryList, "Report Category");
  }

  return (
    <CardElement title="Report Category">
      <>
        <ViewReportCategoryTopBar
          retrieveCategoryData={retrieveCategoryData}
          hmg={hmg}
          setHmg={setHmg}
          project={project}
          setProject={setProject}
          ReportCategoriesLoading={ReportCategoriesLoading}
          exportOnClick={exportOnClick}
          reportCategoryList={reportCategoryList}
          setHmgRef={setHmgRef}
          setProjectRef={setProjectRef}
        />
        {reportCategoryList === undefined ? (
          <Empty description="Please select your filters and click the Go button" />
        ) : (
          <div>
            {reportCategoryList && reportCategoryList.length > 0 ? (
              <HomePageTable>
                <Table
                  className=""
                  columns={columns}
                  dataSource={reportCategoryList}
                  // size="small"
                  rowKey="_id"
                  scroll={{ x: 1100, y: tableHeight }}
                  pagination={{
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "25", "50", "100"],
                  }}
                />
              </HomePageTable>
            ) : (
              <Empty description="No Report Category found" />
            )}
          </div>
        )}
      </>
    </CardElement>
  );
};

ViewReportCategory.propTypes = {};

export default ViewReportCategory;
